module.exports = __webpack_public_path__ + "9b137ad3.woff2";